<template>
    <v-container fluid class="pa-0 stickySidebar">
        <v-row column justify-center align-center no-gutters>
            <!-- <pre>{{ page }}</pre> -->
            <v-col v-if="blogTopics" cols="12" class="widget-wrapper">
                <Widget type="blogTopics" :items="blogTopics" />
            </v-col>
            <v-col v-if="featuredPosts" cols="12" class="widget-wrapper">
                <Widget type="featuredPosts" :items="featuredPosts" />
            </v-col>
            <v-col v-if="recentPosts" cols="12" class="widget-wrapper">
                <Widget type="recentPosts" :items="recentPosts" />
            </v-col>
            <v-col v-if="joinUsOnline" cols="12" class="widget-wrapper">
                <Widget type="joinUsOnline" :items="joinUsOnline" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
// import axios from 'axios'

// import EmbedCloudinary from '~/components/embeds/EmbedCloudinary.vue'
import prependRoute from '~/util/prependRoute'
// import SocialIcons from '~/components/SocialIcons.vue'
import Widget from '~/components/Widget.vue'
export default {
    name: 'PostsSidebar',
    components: {
        // SocialIcons,
        Widget,
    },
    props: {
        page: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            content: [],
        }
    },
    computed: {
        recentPosts() {
            return this.page &&
                this.page.sidebar &&
                this.page.sidebar.recentPosts &&
                this.page.sidebar.recentPosts.length > 0
                ? this.page.sidebar.recentPosts
                : []
        },
        featuredPosts() {
            return this.page &&
                this.page.sidebar &&
                this.page.sidebar.featuredPosts &&
                this.page.sidebar.featuredPosts.length > 0
                ? this.page.sidebar.featuredPosts
                : []
        },
        blogTopics() {
            return this.page &&
                this.page.sidebar &&
                this.page.sidebar.blogTopics &&
                this.page.sidebar.blogTopics.length > 0
                ? this.page.sidebar.blogTopics
                : []
        },
        joinUsOnline() {
            return this.page &&
                this.page.sidebar &&
                this.page.sidebar.joinUsOnline &&
                this.page.sidebar.joinUsOnline.length > 0
                ? this.page.sidebar.joinUsOnline
                : []
        },
    },
    methods: {
        // async fetchContent() {
        //     const api =
        //         'https://tkk9p83q.api.sanity.io/v1/data/query/production?query='
        //     const groq = `*[_type in ["topic","article","whitepaper"] ]{...}`
        //     const query = api + encodeURIComponent(groq)
        //     try {
        //         const { data } = await axios.get(query)
        //         this.content = [...this.content, ...data.result]
        //         // console.log(this.content)
        //     } catch (err) {
        //         console.log('ERROR NAME:', err.name)
        //         console.log('ERROR MESSAGE:', err.message)
        //         console.log('ERROR STACK:', err.stack)
        //     }
        // },
        link(type, slug, locale) {
            const calc = prependRoute({ type, slug })
            return calc[locale] || null
        },
    },
}
</script>
